<div class="p-3 bg-gray">
  <div class="row">
    <div class="d-flex justify-content-between">
      <div class="fs-16 fw-bold font-white mb-3">{{ regionList.RegionID ? "Update" : "Add" }} Region</div>
      <!-- <div [innerHtml]="SVG_ICONS.CLOSE_ICON() | sanitizer : 'html'" (click)="onClose()" tabindex="0" (keydown)="onClose()" class="cursor-pointer ms-auto"></div> -->
    </div>
    <div class="border-bottom mb-2 mt-2"></div>
    <div class="col-md-6 col-12 mt-2">
      <label for="regionName" class="fs-14 fw-normal font-white">Region Name <span class="text-danger">*</span></label>
      <input
        id="regionName"
        class="form-control bg-form-control border-0 font-white"
        onlyCharacter
        maxlength="45"
        [(ngModel)]="regionList.RegionName"
        name="regionName"
        placeholder="Enter Region Name" />
    </div>
    <div class="d-flex justify-content-end mt-5">
      <button class="close-btn me-2 px-4 py-1" (click)="onClose()">Close</button>
      <button class="add-btn px-4 py-1" (click)="onSubmit()">{{ this.regionList.RegionID ? "Update" : "Add" }}</button>
    </div>
  </div>
</div>
